var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-array',{attrs:{"value":_vm.value,"options":_vm.$options.MODES},on:{"input":_vm.selectChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }